import {
  BANK_ID,
  BANK_ID_CONFIRM,
  DOWNSALE,
  MANUAL_PSD2_BANKS,
  PSD2_GUIDE,
  PSD2_VERIFIED,
  UPSALE,
} from 'Router/routes';
import { FakePageData } from '@4finance/cwt-test-helper';

const continuePagesScenario: FakePageData[] = [
  {
    url: BANK_ID,
    items: {
      Continue: [['[data-test="continue"]', 'button']],
    },
  },
  {
    url: BANK_ID_CONFIRM,
    items: {
      Continue: [['[data-test="continue"]', 'button']],
    },
  },
  {
    url: UPSALE,
    items: {
      Continue: [['[data-test="go-to-change-amount"]', 'button']],
    },
  },
  {
    url: MANUAL_PSD2_BANKS,
    items: {
      'Select First Bank': [['[data-test="psd2-banks-bankCard-0"]', 'button']],
    },
  },
  {
    url: PSD2_GUIDE,
    items: {
      Continue: [['[data-test="continue"]', 'button']],
    },
  },
  {
    url: PSD2_VERIFIED,
    items: {
      Continue: [['[data-test="psd2-verified"]', 'button']],
    },
  },
  {
    url: DOWNSALE,
    items: {
      Continue: [['[data-test="downsale-button"]', 'button']],
    },
  },
];

export { continuePagesScenario };
